<template lang="html">
    <div class="section section-light-grey py-5">
        <div class="container">
            <h3 class="text-center mb-4">Sponsorii concursului anual</h3>
            <div class="row">
                <div class="col-sm-3 col-6">
                    <div class="card mb-3 text-center">
                        <div class="card-body">
                            <div class="title">
                                Albume Foto HD
                            </div>
                            <div class="logo">
                                <img src="/media/logo-albumefotohd.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 col-6">
                    <div class="card mb-3 text-center">
                        <div class="card-body">
                            <div class="title">
                                Red Albums
                            </div>
                            <div class="logo">
                                <img src="/media/logo-redalbums.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 col-6">
                    <div class="card mb-3 text-center">
                        <div class="card-body">
                            <div class="title">
                                Caricatours
                            </div>
                            <div class="logo">
                                <img src="/media/logo-caricatours.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 col-6">
                    <div class="card mb-3 text-center">
                        <div class="card-body">
                            <div class="title">
                                Atelierul de caramele
                            </div>
                            <div class="logo">
                                <img src="/media/logo-atelierul-de-caramele.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Sponsors',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.card-body {

    .title {
        margin-bottom: 10px;
    }

    img {

        max-height: 100px;

        @media (max-width: 768px) {
            max-height: 70px;
        }
    }
}

</style>
